var map = {
	"./advancecredits.webp": 35125,
	"./ammo.webp": 18563,
	"./bp_1.webp": 36271,
	"./bp_11.webp": 1806,
	"./bp_13.webp": 77164,
	"./bp_20.webp": 49826,
	"./bp_22.webp": 27072,
	"./bp_23.webp": 57475,
	"./bp_24.webp": 64414,
	"./bp_26.webp": 62812,
	"./bp_27.webp": 69407,
	"./bp_31.webp": 13172,
	"./bp_33.webp": 63510,
	"./bp_37.webp": 92986,
	"./bp_39.webp": 58156,
	"./bp_40.webp": 13896,
	"./bp_42.webp": 15498,
	"./bp_43.webp": 48853,
	"./bp_45.webp": 85031,
	"./bp_47.webp": 39169,
	"./bp_50.webp": 93637,
	"./bp_7.webp": 21981,
	"./bp_8.webp": 16404,
	"./drugs.webp": 10088,
	"./fallback.webp": 36455,
	"./lotocoins.webp": 24309,
	"./metal.webp": 96800,
	"./money.webp": 52003,
	"./rubles.webp": 59806,
	"./status.webp": 38755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85451;